/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Name_PlaceholderInputs */

const en_common_sign_name_placeholder = /** @type {(inputs: Common_Sign_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your name`)
};

/**
* | output |
* | --- |
* | "Enter your name" |
*
* @param {Common_Sign_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_name_placeholder = /** @type {((inputs?: Common_Sign_Name_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Name_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_name_placeholder(inputs)
});
export { common_sign_name_placeholder as "common.sign.name_placeholder" }